import { INew_TableAction } from '@lla-platform/core/core-data-access'

export class GetPaymentsList {
  static readonly type = '[payments] Get Payments List'
  constructor(public info: INew_TableAction) {}
}
